import { Grid, Button, Tooltip } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import EmissionsCategorySelect from "../../../../inputs/vendors/EmissionsCategorySelect";
import SpendBasedVendorInputs from "../../../../inputs/vendors/SpendBasedVendorInputs";

import { useOnVendorSave } from "../../../../../helpers/components/vendors";

const findLatestVendorSurvey = (vendorSurveys = []) => {
  const sorted = [...vendorSurveys].sort(
    (a, b) => Number(b.year) - Number(a.year)
  );
  return sorted[0] || null;
};

const EditVendorDetails = ({
  vendor,
  editVendor,
  vendorSurveys = [],
  hasExplorerAccount = false,
  disabled = false
}) => {
  const { emissionCategory, status } = vendor;
  const { onVendorSave } = useOnVendorSave();

  const latestSurvey = findLatestVendorSurvey(vendorSurveys);
  const isVendorDefinedCategory = hasExplorerAccount && !!latestSurvey;
  const vendorDefinedTooltip =
    "This value is defined by the vendor through their Explorer account.";

  return (
    <Grid container direction="column" spacing={2}>
      <Grid item>
        <Tooltip title={isVendorDefinedCategory ? vendorDefinedTooltip : ""}>
          <span>
            <EmissionsCategorySelect
              value={emissionCategory}
              disabled={isVendorDefinedCategory || disabled}
              setValue={(category) => {
                if (category !== "spend-based") {
                  editVendor("naicsTitle")(null);
                  editVendor("naicsCode")(null);
                  editVendor("tonsCo2ePerDollar")(null);
                }

                return editVendor("emissionCategory")(category);
              }}
            />
          </span>
        </Tooltip>
      </Grid>
      {emissionCategory === "spend-based" && (
        <SpendBasedVendorInputs
          {...vendor}
          editVendor={editVendor}
          naicsDisabled={isVendorDefinedCategory || disabled}
          naicsDisabledTooltip={vendorDefinedTooltip}
        />
      )}
      {status === "unconfirmed" && (
        <Grid item container justifyContent="center">
          <Grid item>
            <Button
              color="secondary"
              variant="contained"
              endIcon={<CheckIcon />}
              onClick={() => onVendorSave(vendor)}
              disabled={disabled}
            >
              Confirm
            </Button>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};
export default EditVendorDetails;
